<template>
<div :style="columnMargin" class="four-grids position-relative">
  <img v-if="item.bgImg" class="ajax-cover-bg" :src='item.bgImg' />
  <img v-else class="ajax-cover-bg" src='/clientmodule/distVueCli/newHomeVue/img/four_grids_bg.png' />
  <div @click="doLocationHref(grids)" v-for="(grids,gridsIndex) in item.catList" :key='gridsIndex' class="grids-one" :class="{'border-right': gridsIndex==0||gridsIndex==2,'border-bottom': gridsIndex==0||gridsIndex==1}">
    <div class="grids-title">
      <span>{{grids.columnCatName}}</span>
      <img v-if='grids.columnCatImg' class="grids-tag" :src="grids.columnCatImg" alt="">
      <!-- <span v-if='grids.columnCatImg' class="grids-tag">超多好物</span> -->
    </div>
    <div class="img-area">
      <img @click.stop="toProdDetail(grids,prod)" v-for="(prod, prodIndex) in grids.prodList" :key='prodIndex' class="grids-img" :src="prod.imgUrl" alt="">
    </div>
  </div>
</div>
</template>

<script>
export default { 
  name: 'FourGrids',
  data() {
    return {

    }
  },
  props: {
    item: Object,
  },
  components: {
    
  },
  created() {
  },
  watch: {
  
  },
  computed: {
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    toProdDetail(grids,obj){
      if(grids.columnCatName != '品牌精选'){
        this.doLocationHref(grids)
        return
      }
      var self = this
      var url = '/client/cpd_' + obj.prodId + '.jhtml'
      if(obj.brandPageId){
        url = '/secondchannel/mTouchBrandHouse.jhtml?pageId='+obj.brandPageId;
      }
      this.$store.commit('doTrack',{
        href: url,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.prodId,
        adName: obj.prodName,
        idType: 'prodId'
      });
      window.location.href = url
    },
    doLocationHref(obj){
      var self = this
      this.$store.commit('doTrack',{
        href: obj.columnCatUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.columnCatDefineId,
        adId: obj.columnCatId,
        adName: obj.columnCatName,
        idType: 'btnId'
      });
      window.location.href = obj.columnCatUrl
    },
  }
}
</script>

<style scoped>
.four-grids{
  width: 345px;
  height: 197px;
  /* background: url(./assets/four_grids_bg.png) no-repeat;
  background-size: 100%; */
  margin: 10px 15px 0;
  font-size: 15px;
  color: #333;
  display: flex;
  flex-wrap: wrap;
}
.grids-one{
  width: 171.5px;
  height: 98px;
}
.grids-title{
  height: 33px;
  /* line-height: 33px; */
  margin-left: 10px;
  display: flex;
  align-items: center;
}
.img-area{
  display: flex;
  /* justify-content: space-evenly; */
}
.grids-img{
  width: 59px;
  height: 59px;
  object-fit: contain;
  display: block;
  margin-left: 17.8px
}
.grids-tag{
  /* font-size: 11px;
  margin-left: 5px;
  padding: 2px 5px;
  background: #FF4852;
  color: #fff;
  border-radius: 3px;
  position: relative;
  top: -1px; */
  width: 49px;
  height: 16px;
  border-radius: 2px;
  display: block;
  margin-left: 4px
}
.border-right{
  border-right: 1px solid #F7F7F7;
}
.border-bottom{
  border-bottom: 1px solid #F7F7F7;
}
</style>